import { AuditEntry, AuditEntryBelow } from "slot-definitions"
import { getAuditPayload } from "routes/audit/controller/get-audits-by-reference-id"
import { IconButton, Stack, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { navigate } from "lib/routes/navigate"
import { uniqueId } from "library/database/split-id.mjs"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useMobile } from "lib/@components/mobile"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_REGIME_AUDITING } from "routes/regime/plugins/regime-auditing/server/feature-flag-regime-auditing.mjs"

AuditEntry("maintenanceRegime").plug(<ShowInfo />)
AuditEntryBelow("maintenanceRegime").plug(<ShowReason if={() => isEnabled(FEATURE_FLAG_REGIME_AUDITING)} />)

function ShowInfo({ id, userName, date, desc }) {
    const { ok, setOpen } = useBoundContext()
    const isMobile = useMobile()
    if (!id) return null
    const payload = getAuditPayload.useResults(id)

    return (
        !!payload?.historyId && (
            <IconButton
                aria-label="View activity"
                color="primary"
                size="small"
                onClick={goToCompare}
                data-cy="activity-entry-preview-button"
            >
                <Iconify icon="ic:outline-remove-red-eye" />
            </IconButton>
        )
    )
    function goToCompare() {
        navigate(`/app/overview/${uniqueId(payload.historyId)}?title=${desc} by ${userName} on ${date}`)
        if (isMobile) {
            ok()
            setOpen(false)
        }
    }
}

function ShowReason({ id }) {
    const payload = getAuditPayload.useResults(id)
    if (!payload?.reason) return null
    const formattedReason = payload.reason.replace(/\n/g, "<br>")
    return (
        !!payload?.reason && (
            <Typography
                variant={"body2"}
                id={`auditInfo-${id}`}
                dangerouslySetInnerHTML={{ __html: formattedReason }}
            ></Typography>
        )
    )
}

export function ShowCustomScheduleReason({ id, reason }) {
    const payload = getAuditPayload.useResults(id) ?? {}
    const { reason: payloadReason, reasonHeader } = payload
    let usingReason = reason ?? payloadReason
    if (!usingReason) return null
    const formattedReason = usingReason.replace(/\n/g, "<br>")
    return (
        <>
            <Stack direction={"row"} alignItems={"center"} spacing={1} mb={0.5}>
                <Iconify
                    icon={
                        reasonHeader === "Rejection Justification"
                            ? "iconoir:chat-bubble-xmark"
                            : "iconoir:chat-bubble-empty-solid"
                    }
                    sx={{ color: reasonHeader === "Rejection Justification" ? "error.main" : "primary.main" }}
                />
                <Typography variant={"body2"} id={`auditInfo-subheading-${id}`}>
                    {reasonHeader ?? "Justification"}
                </Typography>
            </Stack>
            {!!usingReason && (
                <Typography
                    variant="body2"
                    id={`auditInfo-${id}`}
                    dangerouslySetInnerHTML={{ __html: formattedReason }}
                    sx={{ wordBreak: "break-word", whiteSpace: "pre-line" }}
                />
            )}
        </>
    )
}
